export const volumeCheckSpotStates = {
    discoBall: "DISCO_BALL",
    singleBook: "SINGLE_BOOK",
    multipleBooks: "MULTIPLE_BOOKS",
}